// extracted by mini-css-extract-plugin
export default {"Container":"MiddleModelVideo_Container__ZwlVD","UploadBox_right":"MiddleModelVideo_UploadBox_right__kU5Df","UploadBox_right_":"MiddleModelVideo_UploadBox_right___BC0J5"};